<!-- PhoneInput.vue -->
<template>
  <div class="relative">
    <div
      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
    >
      <svg
        class="h-5 w-5 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />
      </svg>
    </div>

    <input
      v-model="internalValue"
      @input="onInput"
      type="tel"
      :placeholder="placeholder"
      :maxlength="16"
      :class="[
        inputClass,
        'pl-10',
        { 'border-red-500': !isValid && internalValue },
      ]"
      v-bind="attrs"
    />

    <p v-if="!isValid && internalValue" :class="errorClass">
      {{ errorMessage }}
    </p>
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, defineExpose } from "vue";
import { useAttrs } from "vue";

const props = defineProps({
  modelValue: String,
  inputClass: String,
  placeholder: {
    type: String,
    default: "Seu WhatsApp/Telefone",
  },
  errorMessage: {
    type: String,
    default:
      "Digite um número de telefone válido (8 ou 9 dígitos após o DDD)",
  },
  errorClass: {
    type: String,
    default: "text-red-500 text-xs mt-1",
  },
});
const emit = defineEmits(["update:modelValue", "validity-changed"]);

const internalValue = ref("");
const attrs = useAttrs();

const isValid = computed(() => {
  const numbers = internalValue.value.replace(/\D/g, "");
  console.log("Dentro de isValid phone-input", internalValue.value === "" || /^\d{10,11}$/.test(numbers));
  return internalValue.value === "" || /^\d{10,11}$/.test(numbers);
});

watch(internalValue, () => {
  emit("validity-changed", isValid.value);
});

// Observa mudanças na prop modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== internalValue.value) {
      const numbers = (newValue || "").replace(/\D/g, "").slice(0, 11);
      internalValue.value = formatPhone(numbers);
      console.log("watch modelValue - novo valor formatado:", internalValue.value);
    }
  }
);

const onInput = () => {
  let numbers = internalValue.value.replace(/\D/g, "").slice(0, 11);
  console.log("number onInput", numbers);
  internalValue.value = formatPhone(numbers);
  console.log("internalValue onInput", internalValue.value);
  emit("update:modelValue", internalValue.value);
};

const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, "");
  if (!numbers) return "";

  const isCellPhone = numbers.length === 11;
  let formatted = numbers;

  if (isCellPhone) {
    formatted = numbers.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
  } else if (numbers.length === 10) {
    formatted = numbers.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  } else if (numbers.length < 10) {
    if (numbers.length > 2)
      formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    if (numbers.length > 6 && isCellPhone) {
      formatted = formatted.slice(0, 6) + " " + formatted.slice(6);
    }
    if (numbers.length > 7) {
      const hyphenPos = isCellPhone ? 9 : 8;
      if (formatted.length > hyphenPos) {
        formatted =
          formatted.slice(0, hyphenPos) + "-" + formatted.slice(hyphenPos);
      }
    }
  }

  return formatted;
};

onMounted(() => {
  // Inicialização do valor
  if (props.modelValue) {
    const numbers = (props.modelValue || "").replace(/\D/g, "").slice(0, 11);
    internalValue.value = formatPhone(numbers);
    console.log("onMounted - valor formatado:", internalValue.value);
    emit("validity-changed", isValid.value);
  }
});

// Expor método de validação e valores para uso externo via ref
defineExpose({
  isValid: () => isValid.value,
  inputValue: internalValue,
  formatPhone
});
</script>